import * as api from '../api';

export const getCustomizations = (slug_id) => api.get(`/projects/${slug_id}/customizations`);
